import React from "react"
import { observer } from "mobx-react-lite"
import { IconButton, LinearProgress } from "@mui/material"
import { Icons } from "../../../misc/Icons"
import { store } from "../../../stores/Store"
import PanelBody from "../../layout/PanelBody"
import PanelHeader from "../../layout/PanelHeader"
import AccountDetails from "./AccountDetails"


export default observer(function AccountTool() {    
    
    const {account, getAccount, setTool} = store.ToolStore
    const [loading, setLoading] = React.useState(true)
    
    React.useEffect(() => {
        if (!account) {
            getAccount().then(() => {
                setLoading(false)
            })
        } else {
            setLoading(false)
        }
    }, [])
    
    return (
        <div className="panel panel-dark">
            <PanelHeader>
                <div className="header">
                    <h2>Account Details</h2>
                </div>

                <IconButton color="info" style={{margin: "0 0 auto auto"}} size="small" onClick={() => store.ToolStore.setTool(null)}><Icons.X /></IconButton>
            </PanelHeader>

            <PanelBody>
                {!account || loading ? (
                    <LinearProgress color="secondary" />
                ) : (
                    <AccountDetails account={account} />
                )}

                <br/>
            </PanelBody>
        </div>
    )
})